import React, { memo } from "react";
import { validators } from "investira.sdk";

import {
  Stack,
  Typography,
  Card,
  Tooltip,
  Icon,
} from "investira.react.components";
import { formats } from "investira.sdk";

const RetornoCard = memo((props) => {
  const {
    value = 0,
    label = "Retorno",
    tooltip,
    tooltipPosition = "label",
    labelProps = {},
    valueProps = {},
    descriptionProps = {},
  } = props;

  const palette = (pValue) => {
    // Retorna a cor conforme o desempenho relativo ao benchmark.
    if (validators.isNull(pValue)) {
      return {
        color: "text.primary",
      };
    }

    if (pValue < 0) {
      return {
        backgroundColor: "error.main",
        color: "error.contrastText",
      };
    } else if (pValue === 0) {
      return {
        backgroundColor: "warning.main",
        color: "background.dark",
      };
    } else if (pValue > 0) {
      return {
        backgroundColor: "primary.main",
        color: "primary.contrastText",
      };
    }

    return {
      color: "text.primary",
    };
  };

  const retornoDescricao = (pValue) => {
    if (validators.isNull(pValue)) return "Sem informação";
    if (pValue < 0) return "Abaixo do benchmark";
    if (pValue === 0) return "Em linha com o benchmark";
    if (pValue > 0) return "Acima do benchmark";
    return "Sem informação";
  };

  const xDescription = retornoDescricao(value);
  const xShowLabelTooltip = tooltip && tooltipPosition === "label";
  const xShowValueTooltip = tooltip && tooltipPosition === "value";

  return (
    <Card
      sx={{
        flex: 1,
        display: "flex",
        minHeight: 0,
        ...palette(value),
      }}
    >
      <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
        <Stack direction="row" justifyContent="space-between">
          <Typography
            variant="caption"
            color="inherit"
            {...labelProps}
            sx={{ fontWeight: 500, ...labelProps.sx }}
          >
            {label}
          </Typography>
          {xShowLabelTooltip && (
            <Tooltip title={tooltip}>
              <span>
                <Icon size={16} color={"inherit"} iconName="information" />
              </span>
            </Tooltip>
          )}
        </Stack>
        <Stack direction="column" justifyContent="flex-end">
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography
              variant={{ xs: "h6", xl: "h5" }}
              color="inherit"
              {...valueProps}
            >
              <b>
                {!validators.isNull(value)
                  ? formats.formatNumber(value, 3, true)
                  : `---`}
              </b>
            </Typography>
            {xShowValueTooltip && (
              <Tooltip title={tooltip}>
                <span>
                  <Icon size={16} color={"inherit"} iconName="information" />
                </span>
              </Tooltip>
            )}
          </Stack>
          <Stack>
            <Typography
              variant={"caption"}
              color="inherit"
              {...descriptionProps}
              sx={{ fontWeight: 500, ...descriptionProps.sx }}
            >
              {xDescription}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
});

export default RetornoCard;
